import type { DriverDailyMetricStatus, DriverDailyShiftMetricAdminDto } from '@/backend/market'

export class DriverDailyMetricEntity {
  id?: string
  driverId?: number
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  regionId?: number
  recordDate?: string
  acceptedOrders?: number
  assignedOrders?: number
  acceptanceRate?: number | null
  scheduledShiftMinutes?: number
  attendedShiftMinutes?: number
  shiftAdherence?: number | null
  dailyHoursScore?: number | null
  activeDeliveryMinutes?: number
  onlineMinutes?: number
  utilization?: number | null
  completedOrders?: number
  ordersPerHour?: number | null
  smoothedOrdersPerHour?: number | null
  isEffectiveDay?: boolean
  qualifiedForProductivity?: boolean
  productivityScore?: number | null
  calculationStatus?: DriverDailyMetricStatus
  shiftMetrics?: DriverDailyShiftMetricAdminDto[] | null
  createdAt?: string
  updatedAt?: string
}
